<template>
  <div class="question-wrapper">
    <question-ask
      @on-success="submitSuccess"
      :position="askPosition"
      :fromId="catalogId"
      :fromPosition="askFromPosition"
      v-if="updateAsk"
      askType="ppt"
    ></question-ask>
    <div class="question-title"><i> </i>提问记录</div>
    <question-list questionType="ppt" v-if="updateList"></question-list>
  </div>
</template>
<script>
import { siteMixin } from "../../../utils/mixin";
import { study } from "../../../request";
import QuestionAsk from "../../exercise/QuestionAsk";
import QuestionList from "../../exercise/QuestionList";
export default {
  mixins: [siteMixin],
  props: {
    course: {
      type: Object,
      default: () => {
        return {};
      },
    },
    specialType: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      askPosition: "cat",
      askFromPosition: "",
      updateAsk: true,
      updateList: true,
    };
  },
  watch: {
    reviewPositionName() {
      this.initParam();
      this.updateAskComponent();
    },
    pptId() {
      // 重新加载
      this.updateAsk = false;
      this.updateList = false;
      this.$nextTick(() => {
        this.updateAsk = true;
        this.updateList = true;
      });
    },
  },
  created() {
    this.initParam();
  },
  methods: {
    initParam() {
      if (
        this.specialType &&
        this.specialType.type &&
        this.specialType.type === 2
      ) {
        this.askPosition = "rev";
        this.askFromPosition = `${this.course.courseName}(${this.specialType.specialName})>${this.reviewPositionName}`;
      }
    },
    updateAskComponent() {
      this.updateAsk = false;
      this.$nextTick(() => {
        this.updateAsk = true;
      });
    },
    submitSuccess() {
      //console.log("ask-success");
      this.updateList = false;
      this.$nextTick(() => {
        this.updateList = true;
      });
    },
  },
  components: {
    QuestionAsk,
    QuestionList,
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/var.less";
@import "../../../assets/css/question.less";
.question-title {
  font-size: 24px;
  font-weight: bold;
  padding: 30px 0;
  border-top: 1px solid #ddd;
  i {
    display: inline-block;
    vertical-align: -0.26em;
    width: 4px;
    height: 28px;
    background: linear-gradient(#2da6fe, #2680fa);
    margin-right: 12px;
  }
}
</style>
